const SC_ROUTER_ADDRESS = "0xB75991a2faCE8f6f40Ee0c2374842CB63eC94390";
const SC_CHAIN_ID = "https://eth-goerli.g.alchemy.com/v2/c6juPVaPTHBesHbQxTUM9D05s6SCidxN" 

export { SC_CHAIN_ID , SC_ROUTER_ADDRESS};